/** Chaves alinhadas ao backend (PdfGeracaoOpcoes / ValidatesPdfGeracaoOpcoes). */
export const PDF_GERACAO_OPCOES_KEYS = [
    'incluir_capa',
    'incluir_cabecalho',
    'incluir_imagem_redacao',
    'incluir_redacao_texto',
    'incluir_competencias_subcriterios',
    'incluir_comentarios_competencias',
    'incluir_correcao_escrita',
    'incluir_rodape_nome_aluno',
    'incluir_qr_code',
];

/** Padrão da API: omitir campo = true; aqui usamos o mesmo para normalização. */
export const DEFAULT_PDF_GERACAO_OPCOES = Object.freeze(
    PDF_GERACAO_OPCOES_KEYS.reduce((acc, k) => {
        acc[k] = true;
        return acc;
    }, {}),
);

/** Rótulos para UI (PT-BR), na ordem das chaves. */
export const PDF_GERACAO_OPCOES_LABELS = Object.freeze({
    incluir_capa: 'Capa',
    incluir_cabecalho: 'Cabeçalho com dados principais',
    incluir_imagem_redacao: 'Imagem da redação (com anotações)',
    incluir_redacao_texto: 'Correção aplicada (com anotações)',
    incluir_competencias_subcriterios:
        'Competências e notas dos subcritérios',
    incluir_comentarios_competencias:
        'Comentários',
    incluir_correcao_escrita: 'Correção textual',
    incluir_rodape_nome_aluno: 'Rodapé com nome do aluno (todas as páginas)',
    incluir_qr_code: 'QR Code (capa/cabeçalho)',
});

/**
 * @param {Record<string, unknown>|null|undefined} partial
 * @returns {Record<string, boolean>}
 */
export function normalizePdfGeracaoOpcoes(partial) {
    const out = { ...DEFAULT_PDF_GERACAO_OPCOES };
    if (partial != null && typeof partial === 'object') {
        for (const key of PDF_GERACAO_OPCOES_KEYS) {
            if (Object.prototype.hasOwnProperty.call(partial, key)) {
                out[key] = Boolean(partial[key]);
            }
        }
        // Exportações antigas: sem incluir_competencias_subcriterios, o legado
        // incluir_comentarios_competencias aplica-se às duas opções (igual ao PDF anterior).
        const hasSubcriteriosKey = Object.prototype.hasOwnProperty.call(
            partial,
            'incluir_competencias_subcriterios',
        );
        if (
            !hasSubcriteriosKey &&
            Object.prototype.hasOwnProperty.call(partial, 'incluir_comentarios_competencias')
        ) {
            const v = Boolean(partial.incluir_comentarios_competencias);
            out.incluir_competencias_subcriterios = v;
            out.incluir_comentarios_competencias = v;
        }
    }
    return out;
}

/**
 * Corpo JSON para POST exportacao-pdf/gerar (booleanos explícitos, um por opção).
 * @param {Record<string, unknown>|null|undefined} partial
 */
export function buildPdfGeracaoOpcoesJsonBody(partial) {
    return normalizePdfGeracaoOpcoes(partial);
}

/**
 * multipart/form-data: envia apenas chaves `false` (omitidas = true no backend).
 * @param {FormData} formData
 * @param {Record<string, unknown>|null|undefined} partial
 */
export function appendPdfGeracaoOpcoesToFormData(formData, partial) {
    if (partial === undefined || partial === null) return;
    const o = normalizePdfGeracaoOpcoes(partial);
    for (const key of PDF_GERACAO_OPCOES_KEYS) {
        if (!o[key]) {
            formData.append(key, '0');
        }
    }
}
